import { createApp } from 'vue'
import './style.css'
import App from './App.vue'

const initialize = async () => {
  const app = createApp(App)
  app.mount('#app')
}

initialize()
